export const lightTheme = {
  colors: {
    primary: "#dc2626",
    primaryLight: "#ef4444",
    primaryDark: "#991b1b",
    secondary: "#8b5cf6",
    bg: "#f8fafc",
    bgElevated: "#ffffff",
    bgSurface: "#f1f5f9",
    text: "#0f172a",
    textSecondary: "#475569",
    textMuted: "#94a3b8",
    border: "#e2e8f0",
    success: "#22c55e",
    error: "#dc2626",
    warning: "#f59e0b",
    info: "#3b82f6",
  },
  shadows: {
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    glow: "0 0 15px rgba(220, 38, 38, 0.2)",
  },
  radius: {
    sm: "0.5rem",
    md: "0.75rem",
    lg: "1.25rem",
  },
  fonts: {
    sans: "'Outfit', sans-serif",
    display: "'Rajdhani', sans-serif",
  }
};

export const darkTheme = {
  colors: {
    primary: "#dc2626",
    primaryLight: "#ef4444",
    primaryDark: "#991b1b",
    secondary: "#8b5cf6",
    bg: "#020617",
    bgElevated: "#0f172a",
    bgSurface: "#1e293b",
    text: "#f8fafc",
    textSecondary: "#cbd5e1",
    textMuted: "#64748b",
    border: "#334155",
    success: "#22c55e",
    error: "#dc2626",
    warning: "#f59e0b",
    info: "#3b82f6",
  },
  shadows: {
    base: "0 4px 6px -1px rgb(0 0 0 / 0.3), 0 2px 4px -2px rgb(0 0 0 / 0.3)",
    md: "0 10px 15px -3px rgb(0 0 0 / 0.4), 0 4px 6px -4px rgb(0 0 0 / 0.2)",
    lg: "0 20px 25px -5px rgb(0 0 0 / 0.4), 0 8px 10px -6px rgb(0 0 0 / 0.2)",
    glow: "0 0 20px rgba(220, 38, 38, 0.4)",
  },
  radius: {
    sm: "0.5rem",
    md: "0.75rem",
    lg: "1.25rem",
  },
  fonts: {
    sans: "'Outfit', sans-serif",
    display: "'Rajdhani', sans-serif",
  }
};
